import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { Header } from '../../components/Header/Header';
import { TableInvoices } from '../../components/Table/TableInvoices/TableInvoices';
import { CdlMenu } from '../../components/CdlMenu/CdlMenu';
import {
  DevedorCadastro,
  useDevedor,
  Devedor as DevedorType,
} from '../../context/ConsultContext';
import { InputTelefoneMask } from '../../components/Inputs/InputTelefoneMask/InputTelefoneMask';
import { Input } from '../../components/Inputs/Input';
import { InputCPFMask } from '../../components/Inputs/InputCPFMask/InputCPFMask';
import { validaCPFCNPJ } from '../../utils/validaCpfCnpj';

import {
  Button,
  Container,
  Content,
  ContentContainer,
  Form,
  FormContainer,
  InputBlock,
} from './styles';
import { useInvoicesTable } from '../../context/TableContext';
import { api } from '../../services/api';
import { InputTelefoneFixoMask } from '../../components/Inputs/InputTelefoneFixoMask/InputTelefoneFixoMask';
import { useLoading } from '../../hooks/useLoading';
import { Loader } from '../../components/Loader/Loader';
import Sidebar from '../../components/Sidebar/Sidebar';
import Footer from '../../components/Footer/Footer';
import { ImUserPlus } from 'react-icons/im';

export function Register() {
  const { setPageParcela, faturaParcelas } = useInvoicesTable();

  const { hideLoader, showLoader, loader } = useLoading();
  const { getDevedor, setDevedor, mostrarData } = useDevedor();
  const navigate = useNavigate();

  const [cpf, setCPF] = useState('');
  const [nome, setNome] = useState('');
  const [cep, setCEP] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [uf, setUF] = useState('');
  const [complemento, setComplemento] = useState('');
  const [numero, setNumero] = useState('');
  const [email, setEmail] = useState('');
  const [telefoneFixo, setTelefoneFixo] = useState('');
  const [telefoneMovel, setTelefoneMovel] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [telefoneFixoComer, setTelefoneFixoComer] = useState('');
  const [telefoneMovelComer, setTelefoneMovelComer] = useState('');

  // eslint-disable-next-line no-useless-escape
  const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const foneFormat = /^\([0-9]{2}\)\s[0-9]{4,5}-[0-9]{4}$/;

  const [text, setText] = useState('');
  const [textCPF, setTextCPF] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [foneMovelError, setFoneMovelError] = useState(false);
  const [foneFixoError, setFoneFixoError] = useState(false);
  const [foneFixoComerError, setFoneFixoComer] = useState(false);
  const [foneMovelComerError, setFoneMovelComer] = useState(false);
  const [whatsappError, setWhatsappError] = useState(false);
  const [cpfError, setCPFError] = useState(false);
  const [cepError, setCepError] = useState(false);

  useEffect(() => {
    setPageParcela('register');
  });

  async function findCep(cep: string) {
    if (cep.length !== 8 && cep.includes('-')) {
      setText('CEP inválido (Somente números)');
      setCepError(true);
      return;
    }

    await axios.get(`https://viacep.com.br/ws/${cep}/json`).then(({ data }) => {
      if (data.erro) {
        setText('CEP não encontrado');
        setLogradouro('');
        setBairro('');
        setCidade('');
        setUF('');
        setCepError(true);
        return;
      }
      setText('');
      setLogradouro(data.logradouro);
      setBairro(data.bairro);
      setCidade(data.localidade);
      setUF(data.uf);
      setCepError(false);
    });
  }

  async function validaCpf(cpf: string) {
    if (!validaCPFCNPJ(cpf)) {
      setTextCPF('CPF/CNPJ inválido');
      setCPFError(true);
      return;
    }
    setTextCPF('');
    setCPFError(false);
  }

  function validaTelefone(telefone: string, nomeCampo: string) {
    if (telefone.length !== 0) {
      if (!foneFormat.test(telefone)) {
        setText(`${nomeCampo} inválido`);
        if (nomeCampo === 'Telefone Fixo') {
          setFoneFixoError(true);
        } else if (nomeCampo === 'Telefone Movel') {
          setFoneMovelError(true);
        } else if (nomeCampo === 'Telefone Fixo Comercial') {
          setFoneFixoComer(true);
        } else if (nomeCampo === 'Telefone Movel Comercial') {
          setFoneMovelComer(true);
        } else if (nomeCampo === 'Whatsapp') {
          setWhatsappError(true);
        }
      }
      return;
    }
    setText('');
    setFoneFixoComer(false);
    setFoneMovelComer(false);
    setFoneFixoError(false);
    setFoneMovelError(false);
  }

  async function validaEmail(email: string) {
    if (!mailFormat.test(email)) {
      setText('Email inválido');
      setEmailError(true);
      return;
    }
    setText('');
    setEmailError(false);
  }

  async function verificarDevedor(cpf: string) {
    validaCpf(cpf);

    const status = await getDevedor(cpf);

    if (status === 200) {
      setTextCPF('CPF/CNPJ já cadastrado');
      setCPFError(true);
      return;
    }

    setTextCPF('');
    setCPFError(false);
  }

  async function handleSubmit(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) {
    e.preventDefault();
    if (
      cpf === '' ||
      nome === '' ||
      cep === '' ||
      logradouro === '' ||
      bairro === '' ||
      cidade === '' ||
      uf === '' ||
      email === '' ||
      telefoneMovel === ''
    ) {
      setText('Preencha todos os campos obrigatórios');
      return;
    } else {
      setText('');

      const devedor: DevedorCadastro = {
        cgc_cpf: cpf,
        nome,
        cep,
        logradouro,
        bairro,
        cidade,
        uf,
        complemento,
        numero_endereco: Number(numero),
        email,
        empresa,
      };
      const telefones = {
        telefone_fixo: telefoneFixo.replaceAll(/\D/g, ''),
        telefone_movel: telefoneMovel.replaceAll(/\D/g, ''),
        whatsapp: whatsapp.replaceAll(/\D/g, ''),
        telefone_fixo_comercial: telefoneFixoComer.replaceAll(/\D/g, ''),
        telefone_movel_comercial: telefoneMovelComer.replaceAll(/\D/g, ''),
      };

      showLoader();
      await api
        .post('devedor/criar', {
          devedor,
          telefones,
          faturas: faturaParcelas,
          credor: '685',
        })
        .then(() => {
          navigate('/consult');
          setDevedor({} as DevedorType);
          mostrarData(false);
          hideLoader();
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setTextCPF('CPF/CNPJ já cadastrado');
            setCPFError(true);
          } else {
            setText('Erro ao cadastrar');
          }
        });

      hideLoader();
    }
  }

  return (
    <Container>
      <Sidebar />
      <Content>
        <Header
          title="Cadastro de Dívidas - Individual"
          icon={<ImUserPlus color="#A6A6A6" size="32px" />}
        >
          <CdlMenu page="cadastro" />
        </Header>
        <ContentContainer>
          <FormContainer>
            <Form>
              <p>Dados do devedor</p>

              <form>
                <InputBlock className="input-block">
                  <InputCPFMask
                    isError={cpfError}
                    name="cpf"
                    label="CPF/CNPJ"
                    size={170}
                    value={cpf}
                    onBlur={(e) => verificarDevedor(e.target.value)}
                    onChange={(e) => setCPF(e.target.value)}
                  />

                  <Input
                    name="name"
                    label="Nome/Razão Social"
                    size={230}
                    value={nome.toUpperCase()}
                    onChange={(e) => setNome(e.target.value)}
                  />
                  <Input
                    name="cep"
                    label="CEP"
                    isError={cepError}
                    size={110}
                    maxLength={8}
                    value={cep}
                    onBlur={(e) => findCep(e.target.value)}
                    onChange={(e) => {
                      setCEP(e.target.value);
                    }}
                  />
                  <Input
                    name="logradouro"
                    label="Logradouro"
                    size={250}
                    value={logradouro.toUpperCase()}
                    onChange={(e) => setLogradouro(e.target.value)}
                  />
                  <Input
                    name="bairro"
                    label="Bairro"
                    value={bairro.toUpperCase()}
                    size={160}
                    onChange={(e) => setBairro(e.target.value)}
                  />
                </InputBlock>

                <InputBlock className="input-block">
                  <Input
                    name="cidade"
                    label="Cidade"
                    size={210}
                    value={cidade.toUpperCase()}
                    onChange={(e) => setCidade(e.target.value)}
                  />
                  <Input
                    name="uf"
                    label="UF"
                    size={60}
                    value={uf.toUpperCase()}
                    onChange={(e) => setUF(e.target.value)}
                    maxLength={2}
                  />
                  <Input
                    name="complemento"
                    label="Complemento"
                    size={170}
                    value={complemento.toUpperCase()}
                    onChange={(e) => setComplemento(e.target.value)}
                    required={false}
                  />
                  <Input
                    name="numero"
                    label="Nº"
                    size={80}
                    maxLength={6}
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                  />
                  <Input
                    name="email"
                    label="Email"
                    type="email"
                    isError={emailError}
                    size={230}
                    value={email}
                    onBlur={(e) => validaEmail(e.target.value)}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <InputTelefoneFixoMask
                    name="fixo"
                    label="Telefone Fixo"
                    isError={foneFixoError}
                    size={140}
                    value={telefoneFixo}
                    onBlur={(e) => {
                      validaTelefone(e.target.value, 'Telefone Fixo');
                    }}
                    onChange={(e) => setTelefoneFixo(e.target.value)}
                  />
                </InputBlock>

                <InputBlock className="input-block">
                  <InputTelefoneMask
                    name="movel"
                    label="Telefone Móvel"
                    isError={foneMovelError}
                    size={140}
                    value={telefoneMovel}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Móvel')
                    }
                    onChange={(e) => setTelefoneMovel(e.target.value)}
                  />
                  <InputTelefoneMask
                    name="whatsapp"
                    label="Whatsapp"
                    isError={whatsappError}
                    size={140}
                    value={whatsapp}
                    onBlur={(e) => validaTelefone(e.target.value, 'Whatsapp')}
                    onChange={(e) => setWhatsapp(e.target.value)}
                  />
                  <Input
                    name="empresa"
                    label="Nome da Empresa"
                    size={340}
                    value={empresa.toUpperCase()}
                    onChange={(e) => setEmpresa(e.target.value)}
                  />
                  <InputTelefoneFixoMask
                    name="fixo_comercial"
                    label="Telefone Fixo (Comercial)"
                    isError={foneFixoComerError}
                    size={140}
                    value={telefoneFixoComer}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Fixo Comercial')
                    }
                    onChange={(e) => setTelefoneFixoComer(e.target.value)}
                  />
                  <InputTelefoneMask
                    name="movel_comercial"
                    label="Telefone Móvel (Comercial)"
                    isError={foneMovelComerError}
                    size={140}
                    value={telefoneMovelComer}
                    onBlur={(e) =>
                      validaTelefone(e.target.value, 'Telefone Móvel Comercial')
                    }
                    onChange={(e) => setTelefoneMovelComer(e.target.value)}
                  />
                </InputBlock>
                <span>{textCPF}</span>
                <br />
                <span>{text}</span>
              </form>
            </Form>

            <TableInvoices />
          </FormContainer>

          <div>
            <Button className="save-info" onClick={(e) => handleSubmit(e)}>
              Salvar informações
            </Button>
          </div>
        </ContentContainer>
        <Footer />
      </Content>
      {loader && <Loader />}
    </Container>
  );
}
